import { tiger } from '../beasts';
import { hangingCharm } from '../motifs';
import { M, PAPER } from '../palette';
import { registerPlate } from '../registry';

/** 12 พยัคฆ์ขาว: the white tiger's plate, warm paper with a white tiger roaring over its left end. */
registerPlate({
  id: 'white-tiger',
  name: 'พยัคฆ์ขาว',
  ground: PAPER,
  trim: M.maroon,
  text: { fill: [M.ink, '#000000'], line: M.whiteHi },
  inset: [21, 11],
  tassels: [{ x: 3 }, { x: -4, charm: 'bell' }],
  front(p, f) {
    tiger(p, f.x + 3, f.b - 2, 1.35, false);
    hangingCharm(p, f.r - 9, f.b, 3);
  },
  motion: {
    sprites: {
      gust: { w: 7, h: 1, draw: (p) => p.rect(0, 0, 7, 1, M.whiteHi).rect(0, 0, 2, 1, M.whiteLo) },
      gust2: { w: 5, h: 1, draw: (p) => p.rect(0, 0, 5, 1, M.whiteHi) },
    },
    play(a, t, f) {
      // The roar's wind: streaks blowing out past the tiger's jaws.
      for (let i = 0; i < 3; i++) {
        const ph = (t * 0.8 + i / 3) % 1;
        a.spr(i % 2 ? 'gust2' : 'gust', f.x + 17 + ph * 10, f.y - 10 + i * 3, Math.sin(ph * Math.PI));
      }
    },
  },
});
